import * as Yup from 'yup';

import editProfileModel from './editProfileModel';

const {
  formField: {
    fullName,
    email,
    emailContact,
    registration,
    cpf,
    phone1,
    phone2,
    area,
    subArea,
    office,
    manager,
    specialNeed,
    zipCode,
    street,
    number,
    complement,
    district,
    city,
    state,
  },
} = editProfileModel;

export default Yup.object().shape({
  [fullName.name]: Yup.string()
    .required(`${fullName.requiredErrorMsg}`)
    .matches(/(\w.+\s).+/i, `${fullName.invalidErrorMsg}`),
  [email.name]: Yup.string()
    .matches(
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
      `${email.invalidErrorMsg}`,
    )
    .required(`${email.requiredErrorMsg}`),
  [emailContact.name]: Yup.string()
    .matches(
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
      `${emailContact.invalidErrorMsg}`,
    )
    .required(`${emailContact.requiredErrorMsg}`),
  [registration.name]: Yup.string().nullable(),
  [cpf.name]: Yup.string().nullable(),
  [phone1.name]: Yup.string(),
  [phone2.name]: Yup.string(),
  [area.name]: Yup.string().required(`${area.requiredErrorMsg}`),
  [subArea.name]: Yup.string().nullable(),
  [office.name]: Yup.string().required(`${office.requiredErrorMsg}`),
  [manager.name]: Yup.string().nullable(),
  [specialNeed.name]: Yup.bool().default(false),
  [zipCode.name]: Yup.string(),
  [street.name]: Yup.string(),
  [number.name]: Yup.string(),
  [complement.name]: Yup.string().nullable(),
  [district.name]: Yup.string(),
  [city.name]: Yup.string(),
  [state.name]: Yup.string(),
});
